import React from 'react';

import '../News/News.css';
import SingleReportHelper from '../../compos/SingleReportHelper/SingleReportHelper';

function SingleReport() {
	return (
		<div className='News'>
			<SingleReportHelper />
		</div>
	);
}

export default SingleReport;
